<template lang="html">
    <form id="addEditReminder" class="form3" @submit.prevent="saveReminder">
        <div class="formGroup" style="margin-top: 10px">
            <label>Reminder title:</label>
            <input type="text" maxlength="50" placeholder="eg Grip" v-model="form.title" />
            <has-error class="info error" :form="form" field="title" />
            <has-error class="info error" :form="form" field="user_id" />
        </div>
        <div class="formGroup">
            <label>Description:</label>
            <textarea-autosize v-model="form.notes" :min-height="30" />
            <has-error class="info error" :form="form" field="notes" />
        </div>

        <button :disabled="form.busy" class="button half" type="submit" name="button">
            {{ form.busy ? "Please wait..." : "Save" }}
        </button>

        <button
            :disabled="form.busy"
            @click.prevent="closeForm"
            class="button red half"
            type="submit"
            name="button"
        >
            Cancel
        </button>
    </form>
</template>

<script>
import { Form, HasError } from "vform";
export default {
    name: "add-edit-reminder",
    components: { HasError },
    props: {
        reminder: {
            required: false,
        },
    },
    computed: {
        player() {
            return this.$store.state.activePlayer;
        },
    },
    created() {
        if (this.reminder) {
            this.form.fill(this.reminder);
        }
        this.$emit("formOpen");
    },
    data() {
        return {
            editOpen: false,
            form: new Form({
                user_id: "",
                title: "",
                notes: "",
            }),
        };
    },
    methods: {
        closeForm() {
            this.$emit("formClosed");
        },
        saveReminder() {
            this.form.user_id = this.player.id;

            if (this.reminder) {
                this.form.put("/reminder/" + this.reminder.id).then((response) => {
                    this.$notify({
                        text: "Reminder updated",
                    });
                    this.$emit("reminderUpdated", response.data);
                    this.closeForm();
                });
            } else {
                this.form.post("/reminder").then((response) => {
                    this.$notify({
                        text: "Reminder saved",
                    });
                    this.$emit("reminderAdded", response.data);
                    this.closeForm();
                });
            }
        },
    },
};
</script>

<style lang="css" scoped>
#addEditReminder {
    margin-bottom: 30px;
}
</style>
